import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthLayoutComponent} from "./core/layout/auth-layout/auth-layout.component";
import {AppLayoutComponent} from "./core/layout/app-layout/app-layout.component";
import {AuthGuard} from "./core/guards/auth.guard";
import { AccessDeniedComponent } from './share/components/access-denied/access-denied.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),
    component: AuthLayoutComponent,
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
    component: AppLayoutComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'user',
    loadChildren: () => import('./modules/user/user.module').then((m) => m.UserModule),
    component: AppLayoutComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'setting',
    loadChildren: () => import('./modules/setting/setting.module').then((m) => m.SettingModule),
    component: AppLayoutComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'letter',
    loadChildren: () => import('./modules/letter/letter.module').then((m) => m.LetterModule),
    component: AppLayoutComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'meeting',
    loadChildren: () => import('./modules/meeting/meeting.module').then((m) => m.MeetingModule),
    component: AppLayoutComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'instruction',
    loadChildren: () => import('./modules/instruction/instruction.module').then((m) => m.InstructionModule),
    component: AppLayoutComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'archive',
    loadChildren: () => import('./modules/archive/archive.module').then((m) => m.ArchiveModule),
    component: AppLayoutComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'contract',
    loadChildren: () => import('./modules/contract/contract.module').then((m) => m.ContractModule),
    component: AppLayoutComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'contractor',
    loadChildren: () => import('./modules/contractor/contractor.module').then((m) => m.ContractorModule),
    component: AppLayoutComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'commerce',
    loadChildren: () => import('./modules/commerce/commerce.module').then((m) => m.CommerceModule),
    component: AppLayoutComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'user-subscriptions',
    loadChildren: () => import('./modules/user-subscriptions/user-subscriptions.module').then(m => m.UserSubscriptionsModule),
    component: AppLayoutComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'events',
    loadChildren: () => import('./modules/event/event.module').then((m) => m.EventModule),
    component: AppLayoutComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'print',
    loadChildren: () => import('./modules/print/print.module').then((m) => m.PrintModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: '/dashboard'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
